import { PawPrint, UserPlus, Mail, KeyRound, ArrowRight } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

interface Props {
  backgroundDataUrl?: string;
}

const steps = [
  {
    icon: UserPlus,
    title: "Załóż konto",
    desc: "na gdzieschronisko.pl/panel",
  },
  {
    icon: Mail,
    title: "Zgłoś swoje schronisko",
    desc: "lub poproś o dostęp do istniejącego",
  },
  {
    icon: KeyRound,
    title: "Aktywuj panel",
    desc: "po krótkiej weryfikacji przez admina",
  },
];

/**
 * Post 1080x1080: Jak założyć / przejąć konto w panelu
 */
export const InstagramPostOwnerPanelHowTo = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 70px",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "10px",
          background: "#2D5A3D",
          padding: "10px 22px",
          borderRadius: "999px",
          marginBottom: "20px",
        }}
      >
        <span
          style={{
            fontSize: "20px",
            fontWeight: 800,
            color: "#FFFFFF",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
          }}
        >
          Jak zacząć
        </span>
      </div>

      <h1
        style={{
          fontSize: "68px",
          fontWeight: 900,
          color: "#2D5A3D",
          margin: "0 0 14px",
          textAlign: "center",
          lineHeight: 1.05,
        }}
      >
        Załóż konto<br />w 3 krokach
      </h1>

      <p
        style={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#5A8A70",
          margin: "0 0 36px",
          textAlign: "center",
          maxWidth: "780px",
          lineHeight: 1.3,
        }}
      >
        Pracujesz w schronisku albo działasz jako wolontariusz?<br />Ten panel jest dla Ciebie.
      </p>

      <div
        style={{
          width: "100%",
          maxWidth: "880px",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <div
            key={title}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "22px",
              background: "#FFFFFF",
              padding: "24px 28px",
              borderRadius: "22px",
              border: "1px solid rgba(45,90,61,0.12)",
              boxShadow: "0 8px 24px rgba(15,42,28,0.08)",
            }}
          >
            <div
              style={{
                background: "#F5F8F6",
                borderRadius: "50%",
                width: "56px",
                height: "56px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                border: "2px solid #2D5A3D",
              }}
            >
              <span style={{ fontSize: "28px", fontWeight: 900, color: "#2D5A3D" }}>{i + 1}</span>
            </div>
            <div
              style={{
                background: "#2D5A3D",
                borderRadius: "16px",
                width: "56px",
                height: "56px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon style={{ width: "28px", height: "28px", color: "#FFFFFF" }} strokeWidth={2.5} />
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "2px", flex: 1 }}>
              <h3
                style={{
                  fontSize: "30px",
                  fontWeight: 800,
                  color: "#2D5A3D",
                  margin: 0,
                  lineHeight: 1.2,
                }}
              >
                {title}
              </h3>
              <p
                style={{
                  fontSize: "22px",
                  fontWeight: 600,
                  color: "#5A8A70",
                  margin: 0,
                  lineHeight: 1.25,
                }}
              >
                {desc}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "32px",
          display: "inline-flex",
          alignItems: "center",
          gap: "12px",
          background: "#2D5A3D",
          padding: "16px 28px",
          borderRadius: "999px",
        }}
      >
        <PawPrint style={{ width: "24px", height: "24px", color: "#FFFFFF" }} />
        <span style={{ fontSize: "24px", fontWeight: 800, color: "#FFFFFF" }}>
          gdzieschronisko.pl/panel
        </span>
        <ArrowRight style={{ width: "22px", height: "22px", color: "#FFFFFF" }} strokeWidth={3} />
      </div>
    </GraphicBackground>
  );
};
